var _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoPopCloseBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.928711,
    y: 14.364,
    width: 19,
    height: 1,
    transform: "rotate(-45 0.928711 14.364)",
    fill: "#0076ff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.63574,
    y: 0.928955,
    width: 19,
    height: 1,
    transform: "rotate(45 1.63574 0.928955)",
    fill: "#0076ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPopCloseBlue);
export default __webpack_public_path__ + "static/media/ico-pop-close-blue.0641570344a8fa39486ddb82c33539f0.svg";
export { ForwardRef as ReactComponent };